import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';

interface IDetailedReportUnitData {
    BusinessUnitId?: number;
    BusinessUnitName?: string;
    Id?: number;
    Name?: string;
}

@Component({
    selector: 'fi-benchmark-item-detailed-report-button',
    template: `
        @if (isSingleUnitReportAvailable()) {
          <button
            mat-icon-button
            (click)="showDetailedAnswersReport(availableUnits[0])"
            >
            <ng-container [ngTemplateOutlet]="buttonContent" />
          </button>
        }
        
        @if (!isSingleUnitReportAvailable()) {
          <button mat-icon-button [matMenuTriggerFor]="businessUnitsMenu">
            <ng-container [ngTemplateOutlet]="buttonContent" />
          </button>
        }
        
        <mat-menu #businessUnitsMenu class="fi-rounded-menu select-business-unit-report-menu">
          @for (unit of availableUnits; track unit) {
            <button
              mat-menu-item
              class="business-unit-button"
              (click)="showDetailedAnswersReport(unit)"
              >
              <mat-icon class="report-button-icon far fa-memo-circle-info" />
              <span class="report-button-label">{{ unit.BusinessUnitName ?? unit.Name }}</span>
            </button>
          }
        </mat-menu>
        
        <ng-template #buttonContent>
          <mat-icon class="detailed-report-icon far fa-memo-circle-info">
            <fi-info-icon
              tooltipClass="fi-rounded-white-tooltip"
              fiInfoPositionMobile="left"
              [mode]="FiInfoIconMode.WithoutIconAbsolute"
              >
              <span>{{ 'checklist.report_see_detailed_report' | fiAppText }}</span>
            </fi-info-icon>
          </mat-icon>
        </ng-template>
        `,
    styleUrls: ['./fi-benchmark-item-detailed-report-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-benchmark-item-detailed-report-button' },
    standalone: false,
})
export class FiChecklistHistoryBenchmarkItemDetailedReportButtonComponent<T extends IDetailedReportUnitData> {
    @Input({ required: true }) availableUnits: T[];
    @Output() onShowDetailedAnswersReport = new EventEmitter<number>();

    isSingleUnitReportAvailable(): boolean {
        return this.availableUnits.length === 1;
    }

    showDetailedAnswersReport(businessUnit: T) {
        return this.onShowDetailedAnswersReport.emit(businessUnit.BusinessUnitId ?? businessUnit.Id);
    }

    protected readonly FiInfoIconMode = FiInfoIconMode;
}
